import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';
import { Calendar } from 'primeng/primeng';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';
import { MasterService } from '../../services';

@Component({
  selector: 'app-arclibreceipt',
  templateUrl: './arclibreceipt.component.html',
  styleUrls: ['./arclibreceipt.component.scss'],
    providers:[LibraryService,MasterService]
})
export class ArclibreceiptComponent implements OnInit {
fserdt:any;
     fserdt4:any;
     recdt:any;
       arrhisfine:any=[];
  constructor(private http: HttpClient, private mservice: MasterService, private liservice: LibraryService,private modalService: NgbModal) { 

    this.getdatetoday();
  }

  ngOnInit(): void {
    this.fineclick();
  }

   fineclick()
  {
    // this.selstat='returned';
    // this.showfine=true;
    this.getissuealsbetdatesfine('bookdetailswithfine','returned');
  }

  getissuealsbetdatesfine(oprtype,bkretstatus) {
  debugger

  console.log('this.fserdt',this.fserdt);
  this.liservice.getlibarchieved(oprtype,bkretstatus,this.fserdt,this.fserdt4)
      .subscribe(
      resultArray => {
          console.log('allcirculated', resultArray);
          this.arrhisfine = resultArray;
          
          
      },
      error => console.log("Error :: " + error)
      )
}

exportbookmas(){
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');
   var url=this.liservice.callurl+"export/expduerecovery_arch.php?clcd="+clcd+"&aycd="+aycd+"&frdt="+this.fserdt+"&todt="+this.fserdt4+"&tag=bookdetailswithfine";

   //window.open(url,'','_blank');
   window.open(url);
 }

getdatetoday() {
    this.liservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.fserdt = resultArray;
            this.fserdt4 = resultArray;
            this.recdt = resultArray;
            
        },
        error => console.log("Error :: " + error)
        )
  }

}
